import React from 'react';
import { Article } from '../../../contexts/ArticlesContext';

interface BulkActionsProps {
  selectedArticleIds: Set<number>;
  bulkAnalyzing: boolean;
  useRelevanceCheck: boolean;
  setUseRelevanceCheck: (value: boolean) => void;
  filteredArticles: Article[];
  onBulkAnalyze: () => void;
  onBulkDeleteAnalysis: () => void;
  onClearSelection: () => void;
}

export function BulkActions({
  selectedArticleIds,
  bulkAnalyzing,
  useRelevanceCheck,
  setUseRelevanceCheck,
  filteredArticles,
  onBulkAnalyze,
  onBulkDeleteAnalysis,
  onClearSelection
}: BulkActionsProps) {
  if (selectedArticleIds.size === 0) {
    return null;
  }

  const hasAnalysisToDelete = filteredArticles.some(article => 
    selectedArticleIds.has(article.id) && (article.hasAnalysis || article.relevanceChecked)
  );

  return (
    <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
      <div className="flex items-center justify-between">
        <p className="text-sm text-blue-800">
          {selectedArticleIds.size} article{selectedArticleIds.size !== 1 ? 's' : ''} selected
        </p>
        <div className="space-x-2">
          <button
            onClick={onBulkAnalyze}
            disabled={bulkAnalyzing}
            className="tc-btn tc-btn-sm tc-btn-primary"
          >
            {bulkAnalyzing ? '⏳ Processing...' : '🤖 Analyze Selected'}
          </button>
          <label className="inline-flex items-center text-sm text-blue-800">
            <input
              type="checkbox"
              checked={useRelevanceCheck}
              onChange={(e) => setUseRelevanceCheck(e.target.checked)}
              className="mr-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            Use Tier 1 Filter
          </label>
          {hasAnalysisToDelete && (
            <button
              onClick={onBulkDeleteAnalysis}
              disabled={bulkAnalyzing}
              className="tc-btn tc-btn-sm bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
            >
              {bulkAnalyzing ? '⏳ Processing...' : '🗑️ Delete Analysis'}
            </button>
          )}
          <button
            onClick={onClearSelection}
            className="tc-btn tc-btn-sm tc-btn-secondary"
          >
            ❌ Clear Selection
          </button>
        </div>
      </div>
    </div>
  );
}